module.exports = __webpack_public_path__ + "static/bringing-soldiers-home-d83e5d2b5971031f906d7836cb207c06.jpg";